import { getSurveyAnswers } from "src/hooks/survey/answers";
import goto from "src/pageDefinitions/goto";
import { getActiveUser } from "@noom/hive-auth";
import { redirectToLogin } from "src/utils/auth";

export const setTelehealthAuthentication = async () => {
  // This action is a temporary solution to fix the user experience
  // necessary due to tight time constraints for the 503a transtion
  // Follow up work to clean up with a better solution will be done here:
  // https://noomhq.atlassian.net/browse/HC-4797
  const activeUser = getActiveUser();
  if (!activeUser) {
    redirectToLogin();
    return;
  }

  const surveyAnswers = getSurveyAnswers();

  const { pdLifting } = surveyAnswers;

  if (pdLifting) {
    // Navigate back to the refill flow
    goto.telehealthEnrollmentSetup();
  }
};
